import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';
import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';

export const GetDeviceStatsData = async () => {
  const response = await SmartLockApiCallerInstance.get(SMART_LOCK_API_ENDPOINTS.GET_DEVICE_STATS);
  return response;
};
export const GetVehicleStatsData = async () => {
  const response = await SmartLockApiCallerInstance.get(SMART_LOCK_API_ENDPOINTS.GET_VEHICLE_STATS);
  return response;
};
export const GetTripStatsData = async () => {
  const response = await SmartLockApiCallerInstance.get(SMART_LOCK_API_ENDPOINTS.GET_TRIP_STATS);
  return response;
};

export const GetDashboardStatsData = async () => {
  const response = await SmartLockApiCallerInstance.get(
    SMART_LOCK_API_ENDPOINTS.GET_DASHBOARD_DATA
  );
  return response;
};

export const ResolveNotification = async (id) => {
  const response = await SmartLockApiCallerInstance.put(
    SMART_LOCK_API_ENDPOINTS.UPDATENOTIFICATIONRESOLVED,
    id
  );
  return response;
};
